/**
 * Child paths under `/warehouse/*` (TRD § Frontend → Route). A leaf module
 * with no imports, so the sidebar and every WMS link can share it without
 * pulling a page in.
 */
export const WAREHOUSE_PATHS = {
  stock: '/warehouse/stock',
  storage: '/warehouse/storage',
  sku: '/warehouse/sku',
  outboundRequest: '/warehouse/outbound-request',
  picking: '/warehouse/picking',
  shipping: '/warehouse/shipping',
  purchaseOrder: '/warehouse/purchase-order',
  vendor: '/warehouse/vendor',
  inboundRequest: '/warehouse/inbound-request',
  goodsReceipt: '/warehouse/goods-receipt',
  /* transfer storage */
  storageTransfer: '/warehouse/storage-transfer',
  /* transfer warehouse (hub → hub) */
  hubTransfer: '/warehouse/hub-transfer',
  /* stock opname */
  stockOpname: '/warehouse/stock-opname',
  /* storage occupancy & map */
  storageOccupancy: '/warehouse/storage-occupancy',
  warehouseMap: '/warehouse/map',
} as const;
